import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { isError, isLoading } from 'reference-resolvers-lite/Status';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import LoadingPropertyValue from './LoadingPropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function isErrorWithMessage(error) {
  return !!error && Object.prototype.hasOwnProperty.call(error, 'message');
}
export default function ResolvedPropertyValue({
  children,
  id,
  objectType
}) {
  const resolver = createStandardCachedResolver(objectType);
  const {
    status,
    reference,
    error
  } = useFetchResolver(resolver, `${id}`);
  if (isLoading(status)) {
    return /*#__PURE__*/_jsx(LoadingPropertyValue, {});
  }
  if (isError(status) || !reference) {
    return /*#__PURE__*/_jsx(Text, {
      as: "span",
      color: "text-alert-default",
      fontStyle: "italic",
      "data-test-id": "resolved-property-value-error",
      children: isErrorWithMessage(error) ? error.message : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkAssetPreviewLib.propertyValue.resolvedValue.error"
      })
    });
  }
  if (children) {
    return children(reference);
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: reference.label
  });
}